module.exports = __webpack_public_path__ + "img/magento-security-services.173b490e.webp";